import React from 'react';
import { H3 } from '../Heading/Heading';
import { FormattedMessage } from 'react-intl';
import NamedLink from '../NamedLink/NamedLink';

import css from './ModalMissingInformation.module.css';

const AccountDetailsReminder = ({ className }) => {
  return (
    <div className={className}>
      <div className={css.reminder}>
        <div className={css.reminderText}>
          <H3 as="h3" className={css.reminderTitle}>
            <FormattedMessage id="ModalMissingInformation.accountDetailsReminder.title" />
          </H3>
        </div>
        <p className={css.reminderDescription}>
          <FormattedMessage id="ModalMissingInformation.accountDetailsReminder.description" />
        </p>
        <div className={css.reminderButton}>
          <NamedLink
            className={css.reminderButtonLink}
            name="ContactDetailsPage"
            to={{
              state: {
                isSeller: true,
              },
            }}
          >
            <FormattedMessage id="ModalMissingInformation.accountDetailsReminder.button" />
          </NamedLink>
        </div>
      </div>
    </div>
  );
};

export default AccountDetailsReminder;
